import React from 'react';
import { useShop } from '../context/ShopContext';
import { useNavigate } from 'react-router-dom';
import { Sparkles, ShoppingBag, Phone, MessageCircle, ArrowRight, Tag, Clock } from 'lucide-react';

export default function MarketingOfferBanner() {
  const { marketingOfferData, storeSettings } = useShop();
  const navigate = useNavigate();

  if (!marketingOfferData || marketingOfferData.isEnabled === false) {
    return null;
  }

  const title = marketingOfferData.title || "✨ TODAY'S SPECIAL JEWELLERY OFFER ✨";
  const subtitle = marketingOfferData.subtitle || "Gold Jewellery Starting at Special Making Charges";
  const discountText = marketingOfferData.discountText || "Get Up To 50% OFF on Making Charges";
  const badge = marketingOfferData.badge || "Limited Time Offer";
  const whatsappNum = marketingOfferData.whatsappNumber || storeSettings?.storePhone || "+919810023456";
  const cleanPhone = whatsappNum.replace(/[^0-9+]/g, '');
  const callPhone = marketingOfferData.phoneNumber || storeSettings?.storePhone || "+919810023456";

  const handleShopNow = () => {
    if (marketingOfferData.shopUrl && marketingOfferData.shopUrl.startsWith('#/')) {
      navigate(marketingOfferData.shopUrl.replace('#', ''));
    } else if (marketingOfferData.shopUrl && marketingOfferData.shopUrl.startsWith('/')) {
      navigate(marketingOfferData.shopUrl);
    } else {
      navigate('/category/all');
    }
  };

  const handleWhatsApp = () => {
    const text = encodeURIComponent(`Namaste M.L. Jewellers! I am interested in the special offer: "${title} - ${discountText}". Please share today's bridal catalog and making charge offers.`);
    window.open(`https://wa.me/${cleanPhone.replace('+', '')}?text=${text}`, '_blank');
  };

  const handleCall = () => {
    window.location.href = `tel:${callPhone.replace(/[^0-9+]/g, '')}`;
  };

  return (
    <section className="marketing-offer-banner-section" style={{
      padding: '0.75rem 1rem 0.25rem',
      background: 'linear-gradient(180deg, #f1f3f6 0%, #fffbf0 100%)',
    }}>
      <div className="container" style={{ maxWidth: '1240px', margin: '0 auto' }}>
        <div 
          className="promo-ad-card"
          style={{
            background: 'linear-gradient(135deg, #781313 0%, #a81c1c 45%, #821414 100%)',
            borderRadius: '10px',
            border: '2px solid #e0b046',
            boxShadow: '0 8px 24px rgba(138, 26, 26, 0.2), 0 2px 6px rgba(0,0,0,0.1)',
            padding: '1.2rem 1.6rem',
            position: 'relative',
            overflow: 'hidden',
            color: '#ffffff',
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '1.2rem'
          }}
        >
          {/* Decorative Gold Shimmer Overlays */}
          <div style={{
            position: 'absolute',
            top: -40,
            right: -40,
            width: '180px',
            height: '180px',
            borderRadius: '50%',
            background: 'radial-gradient(circle, rgba(255, 229, 0, 0.18) 0%, rgba(255, 229, 0, 0) 70%)',
            pointerEvents: 'none'
          }} />
          <div style={{
            position: 'absolute',
            bottom: -30,
            left: '30%',
            width: '140px',
            height: '140px',
            borderRadius: '50%',
            background: 'radial-gradient(circle, rgba(255, 215, 0, 0.12) 0%, rgba(255, 215, 0, 0) 70%)',
            pointerEvents: 'none'
          }} />

          {/* Left Column: Badge, Title & Offer Description */}
          <div style={{ flex: '1 1 520px', minWidth: '280px', zIndex: 2 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.4rem', flexWrap: 'wrap' }}>
              <span style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '0.3rem',
                background: 'linear-gradient(90deg, #ffe500 0%, #ffd000 100%)',
                color: '#781313',
                fontSize: '0.72rem',
                fontWeight: 800,
                textTransform: 'uppercase',
                letterSpacing: '0.06em',
                padding: '0.2rem 0.65rem',
                borderRadius: '4px',
                boxShadow: '0 2px 5px rgba(0,0,0,0.2)'
              }}>
                <Clock size={12} />
                {badge}
              </span>
              <span style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '0.25rem',
                fontSize: '0.72rem',
                color: '#ffe58f',
                fontWeight: 700,
                background: 'rgba(255, 255, 255, 0.12)',
                padding: '0.2rem 0.55rem',
                borderRadius: '4px'
              }}>
                <Tag size={11} />
                Exclusive Showroom Offer
              </span>
            </div>

            <h2 style={{
              margin: '0 0 0.35rem',
              fontSize: 'clamp(1.15rem, 2.2vw, 1.55rem)',
              fontWeight: 800,
              fontFamily: "'Playfair Display', serif, Georgia",
              color: '#ffffff',
              letterSpacing: '0.01em',
              textShadow: '0 2px 4px rgba(0,0,0,0.3)',
              lineHeight: 1.25
            }}>
              {title}
            </h2>

            <p style={{
              margin: '0 0 0.5rem',
              fontSize: 'clamp(0.85rem, 1.5vw, 0.95rem)',
              color: '#fef08a',
              fontWeight: 600,
              lineHeight: 1.35
            }}>
              {subtitle}
            </p>

            <div style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '0.5rem',
              background: 'rgba(0, 0, 0, 0.28)',
              border: '1px solid rgba(255, 229, 0, 0.4)',
              borderRadius: '6px',
              padding: '0.35rem 0.8rem',
              fontSize: '0.88rem',
              fontWeight: 800,
              color: '#fff'
            }}>
              <Sparkles size={16} color="#ffe500" />
              <span style={{ color: '#ffe500' }}>{discountText}</span>
            </div>
          </div>

          {/* Right Column: CTA Buttons */}
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.65rem',
            flexWrap: 'wrap',
            zIndex: 2,
            justifyContent: 'flex-start'
          }}>
            {/* 1. Shop Now Button */}
            <button
              onClick={handleShopNow}
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '0.45rem',
                background: 'linear-gradient(135deg, #ff9f00 0%, #fb641b 100%)',
                color: '#ffffff',
                border: 'none',
                borderRadius: '4px',
                padding: '0.7rem 1.35rem',
                fontSize: '0.88rem',
                fontWeight: 800,
                cursor: 'pointer',
                boxShadow: '0 4px 12px rgba(251, 100, 27, 0.4)',
                transition: 'transform 0.15s ease, box-shadow 0.15s ease',
                textTransform: 'uppercase',
                letterSpacing: '0.03em'
              }}
              onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-2px)'; }}
              onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; }}
            >
              <ShoppingBag size={16} />
              <span>Shop Now</span>
              <ArrowRight size={15} />
            </button>

            {/* 2. WhatsApp Button */}
            <button
              onClick={handleWhatsApp}
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '0.45rem',
                background: '#25D366',
                color: '#ffffff',
                border: 'none',
                borderRadius: '4px',
                padding: '0.7rem 1.2rem',
                fontSize: '0.88rem',
                fontWeight: 700,
                cursor: 'pointer',
                boxShadow: '0 4px 10px rgba(37, 211, 102, 0.3)',
                transition: 'transform 0.15s ease',
                letterSpacing: '0.02em'
              }}
              onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-2px)'; }}
              onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; }}
            >
              <MessageCircle size={16} />
              <span>WhatsApp</span>
            </button>

            {/* 3. Call Now Button */}
            <button
              onClick={handleCall}
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '0.45rem',
                background: 'rgba(255, 255, 255, 0.18)',
                color: '#ffffff',
                border: '1px solid rgba(255, 255, 255, 0.45)',
                borderRadius: '4px',
                padding: '0.68rem 1.15rem',
                fontSize: '0.88rem',
                fontWeight: 700,
                cursor: 'pointer',
                backdropFilter: 'blur(4px)',
                transition: 'background 0.15s ease'
              }}
              onMouseEnter={(e) => { e.currentTarget.style.background = 'rgba(255, 255, 255, 0.28)'; }}
              onMouseLeave={(e) => { e.currentTarget.style.background = 'rgba(255, 255, 255, 0.18)'; }}
            >
              <Phone size={15} />
              <span>Call Now</span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
